import { styled } from "styled-components";

export const InputErrorMessage = styled.div`
  color: #f94e4e;
`;
